import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import User from '@/components/User'
import Book from '@/components/Book'
import Logs from '@/components/Logs'
import AiAccount from '@/components/AiAccount'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
      }, {
        path: '/login',
      name: 'Login',
      component: Login
      }, {
        path: '/user',
      name: 'User',
      component: User
      }, {
        path: '/book',
      name: 'Book',
      component: Book
      }, {
        path: '/logs',
      name: 'Logs',
      component: Logs
      }, {
        path: '/ai-account',
      name: 'AiAccount',
      component: AiAccount
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js